export const sindicationTypes = {
  STANDARD: 'STANDARD',
  FULL: 'FULL',
};
